import styled from 'styled-components'

export type LabelSize = 'sm' | 'md' | 'lg'

const fontSizeMap: Record<LabelSize, string> = {
  sm: '12px',
  md: '16px',
  lg: '18px',
}

const LabelStyle = styled.span<{ size: LabelSize; color?: string; weight?: number }>`
  font-size: ${({ size }) => fontSizeMap[size]};
  font-weight: ${({ weight }) => weight || 400};
  color: ${({ color, theme }) => color || theme.colors.primary};
  margin: 1rem 0;
  text-transform: uppercase;
`

interface LabelProps extends React.HTMLAttributes<HTMLSpanElement> {
  label: string
  size: LabelSize
  weight?: number
  color?: string
}

const Label = ({ label, size, color, weight = 700, ...props }: LabelProps) => {
  return (
    <LabelStyle size={size} color={color} weight={weight} {...props}>
      {label}
    </LabelStyle>
  )
}

export default Label
